<template lang="pug">
  .media.bcard-card-media
    .media-left
      img.media-object.bcard-card-img(:src="app_imgsrc.now_loading" v-src="person.latest_bcard.image_url")
    .media-body
      h4.media-heading.bcard-ui-userdata
        a.text(href="#" @click.prevent="$emit('clickCard', person)", data-testid="-link-name")
          //- 非公開アイコン
          i.fa.bcard-fa-person-private.fa-fw(v-if="person.openflag === app_flag.OFF" title="非公開")
          | {{person.latest_bcard.full_name}}
      .text-body
        div.bcard-ui-userdata(v-if="person.latest_bcard.corporate_name") {{person.latest_bcard.corporate_name}}
        div.bcard-ui-userdata(v-if="person.latest_bcard.dept") {{person.latest_bcard.dept}}
        div.bcard-ui-userdata(v-if="person.latest_bcard.post") {{person.latest_bcard.post}}

      .text-muted.text-nowrap.text-right 名刺履歴: {{person.bcards.length}} 件
</template>

<script>
export default {
  name: 'MergePersonsEditPersonData',
  props: {
    person: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
  .media-body {

    > h4 {
      width: 230px;
    }

    .text-body {
      width: 230px;
    }

    // 名刺履歴 右下固定
    .text-muted.text-nowrap.text-right {
      position: absolute;
      right: 10px;
      bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/maintenance/duplicated-persons/_DetailPersonData.vue